import { render, staticRenderFns } from "./BrandFilter.vue?vue&type=template&id=5aa566f2"
import script from "./BrandFilter.ts?vue&type=script&lang=ts&external"
export * from "./BrandFilter.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports